import { useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '@/shared/api/apiClient';
import { useSessionStore } from '@/entities/session';

export interface UseDeleteInvoiceParams {
  invoiceId: string;
}

export function useDeleteInvoice() {
  const queryClient = useQueryClient();
  const { session } = useSessionStore();

  return useMutation({
    mutationFn: async ({
      invoiceId,
    }: UseDeleteInvoiceParams): Promise<void> => {
      await apiClient.delete(`/operations/bank/deposit/invoices/${invoiceId}`);
    },
    onSuccess: (_, { invoiceId }) => {
      queryClient.invalidateQueries({
        queryKey: ['invoice', invoiceId],
      });
      queryClient.invalidateQueries({
        queryKey: ['invoice-history', session?.userId],
      });
    },
  });
}
